import * as React from 'react';

import { humanizeLearningTime } from 'js/utils/DateTimeUtils';

import { VisuallyHidden } from '@coursera/cds-core';

type Props = {
  className?: string;
  timeCommitment: number;
};

const TimeCommitmentEffortText: React.FC<Props> = ({ className, timeCommitment }) =>
  timeCommitment ? (
    <span className={className}>
      <VisuallyHidden component="span" className="rc-A11yScreenReaderOnly">
        . Duration: {humanizeLearningTime(timeCommitment, true)}
      </VisuallyHidden>
      <span aria-hidden={true}>{humanizeLearningTime(timeCommitment)}</span>
    </span>
  ) : null;

export default TimeCommitmentEffortText;
